import { useQuery } from '@tanstack/react-query';
import { listBankQuestions, type ListBankQuestionsParams } from '../services/question-bank.service';

// The reusable question library for the exam editor. Key includes the filter object per convention.
// Short stale window — the library changes rarely, but a just-added question should show up.
// `enabled` lets a caller behind a modal (QuestionPickerDialog) defer the fetch until it actually
// opens, same as the clip picker does for its own clip-library query.
export function useBankQuestionsQuery(params: ListBankQuestionsParams = {}, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['question-bank', params],
    queryFn: () => listBankQuestions(params),
    staleTime: 30_000,
    enabled: options.enabled ?? true,
  });
}
